var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GridSocialIcons',_vm._b({attrs:{"prevent-links":""}},'GridSocialIcons',_vm.composedProps,false))}
var staticRenderFns = []

export { render, staticRenderFns }